const Menu = theme => ({
	item: {
		color: theme.colors.light.text.primary,
	},
	body: {
		border: `1px solid ${theme.colors.light.neutral.border}`,
	},
});

export {Menu};